/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Mcp_2_DescInputs */

const en_vc_mcp_2_desc = /** @type {(inputs: Vc_Mcp_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batch-export artboards, rename layers, recolour a set of icons or prepare files for print with a single instruction.`)
};

const zh_vc_mcp_2_desc = /** @type {(inputs: Vc_Mcp_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一句话就能批量导出画板、重命名图层、给一套图标换色，或者整理印刷文件。`)
};

/**
* | output |
* | --- |
* | "Batch-export artboards, rename layers, recolour a set of icons or prepare files for print with a single instruction." |
*
* @param {Vc_Mcp_2_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_mcp_2_desc = /** @type {((inputs?: Vc_Mcp_2_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Mcp_2_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_mcp_2_desc(inputs)
	return zh_vc_mcp_2_desc(inputs)
});
export { vc_mcp_2_desc as "vc.mcp.2.desc" }